export default function randomNumber(min:number, max:number, isRounded=true):number {  
	if (isRounded === true){
		min = Math.ceil(min); 
		max = Math.floor(max); 
		return Math.floor(Math.random() * (max - min + 1)) + min;
	} else {
		return Math.random() * (max - min) + min;
	}
}